import axios from "axios"

export default (initalCurrentPage = 1, initialTotalPages = 1, initialLoadMore = true, initialRoute = null, initialPageParameterName = '/p') => ({
    
    currentPage: initalCurrentPage,
    totalPages: initialTotalPages,
    loadMore: initialLoadMore,
    route: initialRoute,
    pageParameterName: initialPageParameterName,

    loading: false,

    init(){    
        this.checkLoadMore();
    },

	load(){

        const self = this;

        if(self.inLimit() && !self.loading){

            self.currentPage++;
            self.loading = true;

            axios.get(self.route + self.pageParameterName + self.currentPage).then(function (response) {
                self.$refs.entries.insertAdjacentHTML('beforeend', response.data);
                self.checkLoadMore();
                self.loading = false;

            });

            let url = new URL(window.location);
            let params = url.searchParams;

            params.set('page', this.currentPage);
            url.search = params.toString();
            
            history.pushState(null, '', url.toString());

        }

    },

    checkLoadMore(){
        this.loadMore = this.inLimit()
    },

    inLimit(){
        return (this.currentPage <= this.totalPages)
    }

})